import { useContext } from 'react'
import UserContext from './userContext'

const Context = () => useContext(UserContext)

export default Context
